module.exports = __webpack_public_path__ + "assets/img/recommend-product.24a086f8.png";